(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elixir-homepage-full"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const locTabs = document.querySelectorAll('.elixir-landing .loc-tab');
    locTabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        const location = e.currentTarget.getAttribute('data-location');
        document.querySelectorAll('.elixir-landing .loc-tab').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.elixir-landing .loc-panel').forEach(p => p.classList.remove('active'));
        e.currentTarget.classList.add('active');
        const panel = document.getElementById('panel-' + location);
        if (panel) panel.classList.add('active');
      });
    });

    const faqQuestions = document.querySelectorAll('.elixir-landing .faq-q');
    faqQuestions.forEach(q => {
      q.addEventListener('click', (e) => {
        const el = e.currentTarget;
        const answer = el.nextElementSibling;
        const isOpen = el.classList.contains('open');

        document.querySelectorAll('.elixir-landing .faq-q').forEach(item => item.classList.remove('open'));
        document.querySelectorAll('.elixir-landing .faq-a').forEach(item => item.classList.remove('open'));

        if (!isOpen) {
          el.classList.add('open');
          answer.classList.add('open');
        }
      });
    });

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fadeEls = document.querySelectorAll('.elixir-landing .fade-up');
    if (reduceMotion) {
      fadeEls.forEach(el => el.classList.add('visible'));
    } else {
      fadeEls.forEach(el => {
        const parent = el.parentElement;
        const idx = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
        el.style.transitionDelay = Math.min(idx * 0.09, 0.45) + 's';
      });
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      fadeEls.forEach(el => observer.observe(el));

      const mosaic = document.querySelector('.elixir-landing .hero-mosaic');
      if (mosaic) {
        let ticking = false;
        window.addEventListener('scroll', () => {
          if (!ticking) {
            window.requestAnimationFrame(() => {
              const offset = Math.min(window.scrollY * 0.06, 40);
              mosaic.style.transform = 'translateY(' + offset + 'px)';
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });
      }

      const statNums = document.querySelectorAll('.elixir-landing .corporate-stats .stat-number');
      if (statNums.length) {
        const targets = [];
        statNums.forEach(el => {
          const tn = el.firstChild;
          if (!tn || tn.nodeType !== 3) return;
          const m = tn.nodeValue.trim().match(/^(\d+)/);
          if (!m) return;
          targets.push({ node: tn, target: parseInt(m[1], 10) });
          tn.nodeValue = '0';
        });
        const cs = document.querySelector('.elixir-landing .corporate-stats');
        if (cs && targets.length) {
          const runCount = () => {
            const dur = 1400, start = performance.now();
            const step = (now) => {
              const p = Math.min((now - start) / dur, 1);
              const ease = 1 - Math.pow(1 - p, 3);
              targets.forEach(t => { t.node.nodeValue = String(Math.round(t.target * ease)); });
              if (p < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
          };
          const so = new IntersectionObserver((entries) => {
            entries.forEach(entry => { if (entry.isIntersecting) { runCount(); so.disconnect(); } });
          }, { threshold: 0.4 });
          so.observe(cs);
        }
      }
    }

    const leadForm = document.getElementById('ElixirLeadForm');
    if (leadForm) {
      leadForm.addEventListener('submit', function() {
        const btn = leadForm.querySelector('.lead-submit');
        if (btn) {
          setTimeout(function() {
            btn.textContent = '✓ Request Received - We will be in touch within 24 hours';
            btn.style.background = '#1a3322';
            btn.disabled = true;
          }, 0);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
